import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";

export default function Safety360() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/safety/overview").then(({ data }) => setData(data)); }, []);
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Safety360" title="Occupational Health & Safety" description="Incidents, near-misses, high-potential events, permits to work, JSA, investigations and fatal-risk controls — leading and lagging indicators." />
            <KpiGrid kpis={data?.kpis || []} accent="green" cols={4} />
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                <Panel title="Incidents (18-month register)" accent="red">
                    <DataTable
                        columns={[
                            { key: "ref", label: "Ref" },
                            { key: "date", label: "Date", render: (r) => r.date.slice(0, 10) },
                            { key: "type", label: "Type" },
                            { key: "area", label: "Area" },
                            { key: "severity", label: "Sev", render: (r) => <StatusChip status={statusToChip(r.severity)}>{r.severity}</StatusChip> },
                            { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status}</StatusChip> },
                            { key: "corrective_actions_open", label: "Open CA" },
                        ]}
                        rows={(data?.incidents || []).slice(0, 30)}
                        testid="safety-incidents"
                    />
                </Panel>
                <Panel title="Live Permits to Work" accent="amber">
                    <DataTable
                        columns={[
                            { key: "permit_no", label: "Permit" },
                            { key: "type", label: "Type" },
                            { key: "area", label: "Area" },
                            { key: "issued_to", label: "Issued to" },
                            { key: "expires", label: "Expires", render: (r) => r.expires.slice(0, 16).replace("T", " ") },
                            { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status}</StatusChip> },
                        ]}
                        rows={(data?.permits || []).slice(0, 20)}
                    />
                </Panel>
            </div>
        </div>
    );
}
